import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const SolariumIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "SolariumIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M21.3953 11.5495C21.7151 11.5495 21.9745 11.2902 21.9745 10.9703V10.1981C21.9745 9.02712 21.0218 8.07447 19.8509 8.07447H4.32918C3.15822 8.07447 2.20557 9.02712 2.20557 10.1981V10.9703C2.20557 11.2901 2.46488 11.5495 2.78474 11.5495H3.75002V16.1828H2.78474C2.46489 16.1828 2.20557 16.4421 2.20557 16.762V17.5342C2.20557 18.7052 3.15822 19.6578 4.32918 19.6578H5.71918V21.3953C5.71918 21.7152 5.97849 21.9745 6.29835 21.9745H17.8817C18.2015 21.9745 18.4609 21.7152 18.4609 21.3953V19.6578H19.8509C21.0218 19.6578 21.9745 18.7052 21.9745 17.5342V16.762C21.9745 16.4421 21.7152 16.1828 21.3953 16.1828H20.43V11.5495H21.3953ZM3.3639 10.1981C3.3639 9.66583 3.79692 9.2328 4.32918 9.2328H19.8509C20.3831 9.2328 20.8161 9.66582 20.8161 10.1981V10.3911H3.3639V10.1981ZM17.3025 20.8161H6.87752V19.6578H17.3025L17.3025 20.8161ZM20.8161 17.5342C20.8161 18.0664 20.3831 18.4995 19.8508 18.4995H4.32918C3.79693 18.4995 3.3639 18.0664 3.3639 17.5342V17.3411H20.8161V17.5342ZM19.2717 16.1828H4.90835V11.5495H19.2717L19.2717 16.1828Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M8.61502 3.36391H9.25237C9.32762 3.73311 9.47334 4.07702 9.67481 4.38089L9.22329 4.83245C8.99711 5.05863 8.99711 5.42532 9.22329 5.65151C9.44947 5.8777 9.81616 5.87769 10.0423 5.65151L10.4939 5.19995C10.7978 5.40142 11.1416 5.54714 11.5109 5.62239V6.25974C11.5109 6.57959 11.7702 6.83891 12.0901 6.83891C12.4099 6.83891 12.6692 6.5796 12.6692 6.25974V5.62239C13.0384 5.54714 13.3823 5.40142 13.6862 5.19995L14.1378 5.65151C14.3639 5.87769 14.7306 5.87769 14.9568 5.65151C15.183 5.42533 15.183 5.05864 14.9568 4.83245L14.5053 4.38089C14.7067 4.07702 14.8525 3.73315 14.9277 3.36391H15.565C15.8849 3.36391 16.1442 3.1046 16.1442 2.78474C16.1442 2.46488 15.8849 2.20557 15.565 2.20557H8.61503C8.29518 2.20557 8.03586 2.46488 8.03586 2.78474C8.03586 3.1046 8.29516 3.36391 8.61502 3.36391ZM13.7283 3.36391C13.4892 4.0381 12.8451 4.52224 12.09 4.52224C11.3349 4.52224 10.6908 4.03809 10.4517 3.36391H13.7283Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default SolariumIcon;
